<template>
  <div class="fixed top-0 left-0 right-0 z-50">
    <transition name="alert-animation">
      <div v-if="!onLine" class="bg-red-hover text-white text-md text-center p-4">
        {{ $t('goneOffLine') }}
      </div>
      <div v-if="showBackOnline" class="bg-green text-white text-md text-center p-4">
        {{ $t('backOnLine') }}
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "OfflineAlert",
  data() {
    return {
      onLine: navigator.onLine,
      showBackOnline: false
    }
  },
  methods: {
    updateOnlineStatus(e) {
      const {type} = e;
      this.onLine = type === 'online';
    }
  },
  watch: {
    onLine(v) {
      if (v) {
        this.showBackOnline = true;
        setTimeout(() => {
          this.showBackOnline = false;
        }, 1000);
      }
    }
  },
  mounted() {
    window.addEventListener('online', this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);
  },
  beforeDestroy() {
    window.removeEventListener('online', this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);
  },
  i18n: {
    messages: {
      en: {
        goneOffLine: 'Lost network connection, check connection.',
        backOnLine: 'Connection reestablished.'
      },
      ru: {
        goneOffLine: 'Потеряно соединение с сетью, проверьте подключение.',
        backOnLine: 'Подключение восстановлено.'
      },
    }
  }
}
</script>

<style lang="scss" scoped>
.alert-animation-enter-active {
  animation: fadeEnterFromTop .4s ease-in;
  animation-delay: .2s;
  opacity: 0;
}

.alert-animation-leave-active {
  animation: fadeLeaveToTop .3s ease-out;
}

@keyframes fadeLeaveToTop {
  from {
    opacity: 1;
    transform: translateY(0)
  }
  to {
    opacity: 0;
    transform: translateY(-50px)
  }
}

@keyframes fadeEnterFromTop {
  from {
    opacity: 0;
    transform: translateY(-50px)
  }
  to {
    opacity: 1;
    transform: translateY(0)
  }
}
</style>